import { render, staticRenderFns } from "./danhSachKhoaHocTrenWebsite.vue?vue&type=template&id=1a2b441e"
import script from "./danhSachKhoaHocTrenWebsite.vue?vue&type=script&lang=js"
export * from "./danhSachKhoaHocTrenWebsite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports